import * as React from "react";
import Skeleton from "@mui/material/Skeleton";

export default function BrandStatsCardSkeleton() {
  return (
    <div className="brand-stats-card">
      <div className="user-statistics">
        <div
          className="user-stats-content"
          style={{ display: "flex", flexDirection: "column" }}
        >
          <Skeleton variant="text" width="40%" sx={{ fontSize: "1rem" }} />
          <div className="donut-chart">
            <Skeleton
              animation="wave"
              sx={{ bgcolor: "grey.300", marginTop: "10px" }}
              variant="circular"
              width={150}
              height={150}
            />
          </div>
          <div className="legend">
            <div style={{ display: "flex", justifyContent: "space-around" }}>
              <Skeleton variant="text" width="10%" sx={{ fontSize: "1rem" }} />
              <Skeleton variant="text" width="70%" sx={{ fontSize: "1rem" }} />
            </div>
            <div style={{ display: "flex", justifyContent: "space-around" }}>
              <Skeleton variant="text" width="10%" sx={{ fontSize: "1rem" }} />
              <Skeleton variant="text" width="70%" sx={{ fontSize: "1rem" }} />
            </div>
            <div style={{ display: "flex", justifyContent: "space-around" }}>
              <Skeleton variant="text" width="10%" sx={{ fontSize: "1rem" }} />
              <Skeleton variant="text" width="70%" sx={{ fontSize: "1rem" }} />
            </div>
            <div style={{ display: "flex", justifyContent: "space-around" }}>
              <Skeleton variant="text" width="10%" sx={{ fontSize: "1rem" }} />
              <Skeleton variant="text" width="70%" sx={{ fontSize: "1rem" }} />
            </div>
          </div>
        </div>
      </div>
      <div className="brand-tabs">
        <div
          className="tabs"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Skeleton variant="rounded" width={250} height={40} />
          <Skeleton variant="rounded" width={250} height={40} />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-evenly",
            alignItems: "end",
          }}
        >
          <Skeleton variant="rounded" width={40} height={180} />
          <Skeleton variant="rounded" width={40} height={160} />
          <Skeleton variant="rounded" width={40} height={120} />
          <Skeleton variant="rounded" width={40} height={140} />
          <Skeleton variant="rounded" width={40} height={180} />
          <Skeleton variant="rounded" width={40} height={160} />
          <Skeleton variant="rounded" width={40} height={140} />
          <Skeleton variant="rounded" width={40} height={160} />
          <Skeleton variant="rounded" width={40} height={120} />
        </div>
      </div>
    </div>
  );
}
